/**
 * Turn any thrown error / Axios error into a human-readable string.
 * Fixes the `Upload failed: [object Object]` toast bug that happens when
 * the backend returns a FastAPI validation error (`detail` is an array of
 * `{loc, msg, type}` objects, not a string).
 */
export function errMsg(e) {
  if (!e) return "Unknown error";
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => d?.msg || d?.type || JSON.stringify(d))
      .filter(Boolean)
      .join("; ");
  }
  if (detail && typeof detail === "object") {
    return detail.msg || JSON.stringify(detail);
  }
  if (typeof e.message === "string") return e.message;
  return String(e);
}
